<script>
import MD from 'markdown-it'

const md = MD()

export default {
  computed: {
    html() {
      return md.render(this.content)
    }
  },
  props: {
    content: {type: String, default: () => ''}
  }
}
</script>

<template>
<div class='doc-text my-2' v-html='html'/>
</template>

<style lang='sass' scoped>
.doc-text
  font-size: 1.1em
  ::v-deep h1
    font-weight: 500
    margin-bottom: 0.5em
  ::v-deep h2
    font-weight: 500
    margin-bottom: 0.5em
  ::v-deep h3
    font-weight: 400
    margin-bottom: 0.5em
  ::v-deep h4
    font-weight: 400
    margin-bottom: 0.5em
  ::v-deep h5
    font-weight: 400
    margin-bottom: 0.5em
  ::v-deep h6
    font-weight: 400
    margin-bottom: 0.5em
  ::v-deep p
    margin-bottom: 0.5em
  ::v-deep code
    padding: 0.25em
  ::v-deep code
    padding-bottom: 0
    padding-top: 0
  ::v-deep pre code
    padding-bottom: 0.25em
    padding-left: 0.4em
    padding-right: 0.4em
    padding-top: 0.4em
    margin-bottom: 1em
  ::v-deep pre code:after
    content: none
  ::v-deep pre code:before
    content: none
  ::v-deep hr
    margin-bottom: 1em
    margin-top: 1em

  ::v-deep ul
    margin-bottom: 1em
    a
      text-decoration: none
</style>
